// @ts-nocheck
import { useEffect, useRef, useState } from "react";
import { X } from "react-feather";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useDropzone } from "react-dropzone";

import { useDispatch, useSelector } from "react-redux";

import "./Styles/Styles.scss";
import ChooseFile from "./DropBoxChooser";
import { receiveValidationErrors } from "../Errors/errorActions";
import DrivePicker from "./GoogleDriveChooser";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { DropBoxAppKey } from "../../constants";
import DropboxAuth from "./DropboxAuth";
import { updateTutorialState } from "../Tutorials/TutorialActions";

const addLinkIcon =
  require(`@src/assets/images/vyrill/videos/addLink.png`).default;

const videoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="146"
    height="107"
    viewBox="0 0 146 107"
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M99.5455 0C101.306 0 102.994 0.704575 104.238 1.95872C105.483 3.21287 106.182 4.91386 106.182 6.6875V34.775L140.777 10.3656C141.275 10.0142 141.858 9.8072 142.464 9.7671C143.071 9.727 143.676 9.85537 144.215 10.1382C144.754 10.4211 145.205 10.8475 145.52 11.3711C145.835 11.8947 146.001 12.4953 146 13.1075V93.8925C146.001 94.5047 145.835 95.1053 145.52 95.6289C145.205 96.1525 144.754 96.5789 144.215 96.8618C143.676 97.1446 143.071 97.273 142.464 97.2329C141.858 97.1928 141.275 96.9858 140.777 96.6344L106.182 72.225V100.312C106.182 102.086 105.483 103.787 104.238 105.041C102.994 106.295 101.306 107 99.5455 107H6.63636C4.87629 107 3.18831 106.295 1.94375 105.041C0.699186 103.787 0 102.086 0 100.312V6.6875C0 4.91386 0.699186 3.21287 1.94375 1.95872C3.18831 0.704575 4.87629 0 6.63636 0H99.5455ZM92.9091 13.375H13.2727V93.625H92.9091V13.375ZM53.0909 26.75L79.6364 53.5H59.7273V80.25H46.4545V53.5H26.5455L53.0909 26.75ZM132.727 32.3742L106.182 51.0992V55.9008L132.727 74.6258V32.3742Z"
      fill="#E0F9F9"
    />
  </svg>
);

type UploadPersonalVideoProps = {
  uploadVideoModal: boolean;
  setUploadVideoModal: (state: boolean) => void;
  setStep1Modal: (state: boolean) => void;
  fileHandler: (file: File) => void;
  onDropboxSuccess: (files: File[]) => void;
  onGoogleDriveSuccess: (files: File[]) => void;
  redirectUri: string;
  setAuthorizationToken: any;
  driveAccessToken: string;
  setDriveAccessToken: any;
};

const UploadPersonalVideo: React.FC<UploadPersonalVideoProps> = ({
  uploadVideoModal,
  setUploadVideoModal,
  setStep1Modal,
  fileHandler,
  onDropboxSuccess,
  onGoogleDriveSuccess,
  redirectUri,
  setAuthorizationToken,
  driveAccessToken,
  setDriveAccessToken,
  setChooserOpen,
  chooserOpen,
}) => {
  const dropboxRef = useRef<HTMLInputElement>(null);
  const DriveRef = useRef<HTMLInputElement>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "video/mp4": [".mp4, .mov"] },
    maxFiles: 1,
    noDragEventsBubbling: true,
    noClick: true,
    onFileDialogCancel: () => setDropdownOpen(false),
    onDrop: (acceptedFiles) => {
      fileHandler(acceptedFiles[0]);
      setDropdownOpen(false);
    },
  });

  const openVideoModal = useSelector(
    (state) => state.tutorials_states.openVideoModal
  );

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const addLocalVideo = () => {
    document.getElementById("fileInput")?.click();
  };

  const addDropboxvideo = () => {
    if (dropboxRef.current) {
      dropboxRef.current.click();
      setDropdownOpen(false);
    }
  };

  const addDrivevideo = () => {
    if (DriveRef.current) {
      DriveRef.current.click();
      setDropdownOpen(false);
    }
  };

  const authorizeWithGoogle = () => {
    const driveKeys = localStorage.getItem("driveKeys");
    if (driveKeys) {
      const expiresOn = JSON.parse(driveKeys).expiresOn;
      const access_token = JSON.parse(driveKeys).access_token;
      const code = JSON.parse(driveKeys).code;

      if (Date.now() > expiresOn) {
        localStorage.removeItem("driveKeys");
        setAuthorizationToken("");
        setDriveAccessToken("");
      } else if (driveAccessToken) {
        addDrivevideo();
        return;
      } else {
        setAuthorizationToken(code);
        setDriveAccessToken(access_token);
        return;
      }
    }
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const scope = "https://www.googleapis.com/auth/drive.readonly";

    const state = encodeURIComponent(
      JSON.stringify({
        selectedDropdown: "GoogleDrive",
        page: window.location.href,
        redirectUri,
      })
    );

    const driveAuthUrl =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=${scope}` +
      `&state=${state}`;

    window.location.href = driveAuthUrl;
  };

  const authorizeDropbox = () => {
    setChooserOpen(true);
    const clientId = DropBoxAppKey;
    const selectedDropdown = "DropBox";
    const state = encodeURIComponent(JSON.stringify({ selectedDropdown }));
    const authorizationDropboxToken = sessionStorage.getItem(
      "authorizationDropboxToken"
    );
    if (authorizationDropboxToken) {
      addDropboxvideo();
    } else {
      const authUrl = `https://www.dropbox.com/oauth2/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&state=${state}`;
      window.location.href = authUrl;
    }
  };

  useEffect(() => {
    const code = searchParams.get("code");
    const access_token = searchParams.get("access_token");
    const expires_in = searchParams.get("expires_in");
    const selectedDropdown = searchParams.get("selectedDropdown");
    if (code && access_token) {
      if (selectedDropdown === "GoogleDrive") {
        setUploadVideoModal(true);
        const object = {
          code,
          access_token,
          expiresOn: Date.now() + (Number(expires_in) || 0) * 1000,
        };
        localStorage.setItem("driveKeys", JSON.stringify(object));
        setAuthorizationToken(code);
        setDriveAccessToken(access_token);
        setSearchParams("");
      }
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    if (code && state) {
      const stateObject = JSON.parse(state);
      const { selectedDropdown, page, authComplete } = stateObject;
      const originalRedirectURL = stateObject.redirectUri;
      if (selectedDropdown === "GoogleDrive") {
        // Handle Google Drive authentication
        // setUploadVideoModal(true);
        setAuthorizationToken(code);
        const state = encodeURIComponent(
          JSON.stringify({
            selectedDropdown: "GoogleDrive",
            page,
            authComplete: true,
          })
        );

        if (!authComplete) {
          const body =
            `code=${code}` +
            `&client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}` +
            `&client_secret=${process.env.REACT_APP_GOOGLE_CLIENT_SECRET}` +
            `&redirect_uri=${originalRedirectURL}` +
            `&grant_type=authorization_code&state=${state}`;

          fetch("https://oauth2.googleapis.com/token", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body,
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.access_token) {
                location.replace(
                  `${page}?${createSearchParams({
                    ...data,
                    code,
                    selectedDropdown: "GoogleDrive",
                  }).toString()}`
                );
              }
            });
        }
      }
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    if (code && state) {
      const stateObject = JSON.parse(state);
      if (stateObject?.selectedDropdown === "DropBox") {
        setUploadVideoModal(true);
        sessionStorage.setItem("authorizationDropboxToken", code);
        setChooserOpen(true);
        window.history.pushState(null, "", window.location.origin);
      }
    }
  }, []);

  return (
    <Modal
      size="lg"
      isOpen={openVideoModal ? openVideoModal : uploadVideoModal}
      className="upload-local VideoProcess modal-dialog-centered "
      style={{ maxWidth: "984px" }}
    >
      <ModalHeader className="justify-content-end m-3">
        <X
          className="closeBtn"
          style={{ top: "18px", right: "18px" }}
          strokeWidth={1}
          color="black"
          size={50}
          role="button"
          onClick={() => {
            setAuthorizationToken("");
            setDriveAccessToken("");
            setChooserOpen(false);
            sessionStorage.removeItem("authorizationDropboxToken");
            setUploadVideoModal(false);
            setDropdownOpen(false);
            dispatch(updateTutorialState({ openVideoModal: false }));
          }}
        />
      </ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <div
            {...getRootProps({ className: "dropzone" })}
            className="drop-zone"
          >
            <input
              type="file"
              className="d-none"
              id="fileInput"
              {...getInputProps()}
            />
            <div className="d-none">
              <ChooseFile
                onDropboxSuccess={onDropboxSuccess}
                clearFieldError={() => dispatch(receiveValidationErrors({}))}
                dropboxRef={dropboxRef}
                chooserOpen={chooserOpen}
                setChooserOpen={setChooserOpen}
                // authorizationDropboxToken={authorizationDropboxToken}
              />
              <DrivePicker
                onGoogleDriveSuccess={onGoogleDriveSuccess}
                DriveRef={DriveRef}
                driveAccessToken={driveAccessToken}
              />
            </div>
            <div className="align">{videoIcon}</div>
            <div className="mt-4 d-flex flex-column align-items-center">
              <p className="mb-4 drag">Drag and drop videos to upload</p>
              <Dropdown
                className="multi-format-dropdown"
                style={{ width: "178px" }}
                isOpen={dropdownOpen}
                toggle={toggle}
              >
                <DropdownToggle
                  style={{
                    width: "178px",
                    height: "48px",
                    fontSize: "16px",
                    borderRadius: "10px",
                  }}
                  color="primary"
                  className="p-0"
                >
                  Select File
                </DropdownToggle>
                <DropdownMenu style={{width:"153px !important"}}>
                  <DropdownItem onClick={addLocalVideo}>
                    <span style={{ color: "#7D8398", fontSize: "13px" }}>
                      Local Computer
                    </span>
                    <svg
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        // eslint-disable-next-line max-len
                        d="M11.8182 0H1.18182C0.531818 0 0 0.54 0 1.2V8.4C0 9.06 0.531818 9.6 1.18182 9.6H5.31818L4.13636 11.4V12H8.86364V11.4L7.68182 9.6H11.8182C12.4682 9.6 13 9.06 13 8.4V1.2C13 0.54 12.4682 0 11.8182 0ZM11.8182 7.2H1.18182V1.2H11.8182V7.2Z"
                        fill="#7D8398"
                      />
                    </svg>
                  </DropdownItem>
                  <DropdownItem divider />
                  {/* <DropdownItem onClick={addDropboxvideo}>
                    <span style={{ color: "#7D8398", fontSize: "13px" }}>
                      Dropbox
                    </span>
                    <svg
                      width="15"
                      height="13"
                      viewBox="0 0 15 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        // eslint-disable-next-line max-len
                        d="M0 2.44706L3.75 4.88647L7.5 2.44706L3.75 0L0 2.44706ZM7.5 2.44706L11.25 4.88647L15 2.44706L11.25 0L7.5 2.44706ZM0 7.30294L3.75 9.74235L7.5 7.30294L3.75 4.85588L0 7.30294ZM11.25 4.85588L7.5 7.30294L11.25 9.74235L15 7.30294L11.25 4.85588ZM3.7725 10.5529L7.53 13L11.28 10.5529L7.53 8.11353L3.7725 10.5529Z"
                        fill="#7D8398"
                      />
                    </svg>
                  </DropdownItem> */}

                  <DropdownItem onClick={() => authorizeDropbox()}>
                    <span style={{ color: "#7D8398", fontSize: "13px" }}>
                      Dropbox
                    </span>
                    <svg
                      width="15"
                      height="13"
                      viewBox="0 0 15 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        // eslint-disable-next-line max-len
                        d="M0 2.44706L3.75 4.88647L7.5 2.44706L3.75 0L0 2.44706ZM7.5 2.44706L11.25 4.88647L15 2.44706L11.25 0L7.5 2.44706ZM0 7.30294L3.75 9.74235L7.5 7.30294L3.75 4.85588L0 7.30294ZM11.25 4.85588L7.5 7.30294L11.25 9.74235L15 7.30294L11.25 4.85588ZM3.7725 10.5529L7.53 13L11.28 10.5529L7.53 8.11353L3.7725 10.5529Z"
                        fill="#7D8398"
                      />
                    </svg>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={authorizeWithGoogle}>
                    <span style={{ color: "#7D8398", fontSize: "13px" }}>
                      Google Drive
                    </span>
                    <svg
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.50542 0C5.37767 0 4.472 0.0108333 4.47796 0.0254583C4.48338 0.0362916 5.40313 1.651 6.52221 3.61129L8.55888 7.17221H10.5955C11.7228 7.17221 12.6284 7.16138 12.6225 7.14675C12.6198 7.13592 11.6973 5.52121 10.5777 3.56092L8.541 0H6.50542ZM3.92708 0.937083C3.26641 2.07498 2.61098 3.21593 1.96083 4.35988L0 7.79079L1.02375 9.57721L2.04479 11.3631L4.00563 7.93163L5.96537 4.50288L4.94704 2.72242C4.3875 1.74363 3.92979 0.940333 3.92708 0.937083ZM5.15071 7.79079L5.04075 7.97929C4.979 8.08654 4.52075 8.88496 4.02242 9.75975C3.718 10.2972 3.41141 10.8335 3.10267 11.3685C3.09725 11.3826 4.85767 11.3912 7.01458 11.3912H10.9384L11.9113 9.68121C12.4486 8.74196 12.9133 7.93163 12.9437 7.88125L13 7.79079H9.07346H5.15071Z"
                        fill="#7D8398"
                      />
                    </svg>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div
              className="d-flex align-items-center gap-1 mt-4"
              role="button"
              onClick={() => {
                setAuthorizationToken("");
                setDriveAccessToken("");
                setUploadVideoModal(false);
                setStep1Modal(true);
                setChooserOpen(false);
                sessionStorage.removeItem("authorizationDropboxToken");
              }}
            >
              <img width={22} src={addLinkIcon} />
              <span style={{ color: "#783AD0", fontSize: "18px" }}>
                Add a video link
              </span>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UploadPersonalVideo;
